export const PROJECTS_WITH_LOGISTIC_DEFAULT_ETA = ['quickiedelivery']
